import { supabase } from "@/integrations/supabase/client";

export async function isLoginNotificationEnabled(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc("get_app_setting", {
      setting_key: "login_notifications_enabled",
    });

    if (error) {
      console.error("Error checking login notification setting:", error);
      return true; // Default to enabled for backward compatibility
    }

    return Boolean(data);
  } catch (error) {
    console.error("Failed to check login notification setting:", error);
    return true; // Default to enabled on error
  }
}
